import { Services } from '@microfrontends/react-components'
import { EProfile, TResumeSettingInfo, TResumeSettingMeta } from '../../services/types/resume'
import { TDispatchAction, TProfileSettingInfo } from '../../store'
import { Dispatch } from 'react'
import { ACTION_SET_RESUME_SETTING_INFO } from '../../store/actions'

const DEFAULT_RESUME_ATTRIBUTE = {
    allowSearchableDisplay: 0,
    fileName: '',
    link: '',
    size: 0,
    id: 0,
    isAttach: 0,
    isSearchable: 0,
    updatedDate: 0
}

const { ModelError } = Services

function syncProfileSettingInfoStore(
    info: {
        data?: Partial<TResumeSettingInfo>
        meta?: Partial<TResumeSettingMeta>
    },
    currentStoreInfo: TProfileSettingInfo,
    dispatch: Dispatch<TDispatchAction>
): [typeof ModelError | string] {
    const { data, meta } = info
    const currentInfo = currentStoreInfo
    if (!data?.attributes || data?.attributes?.length < 1) {
        let value = new ModelError({
            data: null,
            error: {
                details: {
                    ERROR_UPDATE: "Can't update data to store"
                },
                status: 500,
                message: "Can't update data to store"
            }
        })
        return [value as typeof ModelError]
    }

    const attach = data?.attributes?.filter((cv) => cv.isAttach === EProfile.isAttach)
    const profile = data?.attributes?.find((cv) => cv.isAttach === EProfile.isProfile)
    const clonedProfileSettingInfo = JSON.parse(JSON.stringify(currentInfo))

    dispatch({
        type: ACTION_SET_RESUME_SETTING_INFO,
        payload: {
            ...clonedProfileSettingInfo,
            resumeSetting: {
                attachInfo: attach,
                profileInfo: profile ?? DEFAULT_RESUME_ATTRIBUTE
            },
            searchableStatus: data.searchableStatus,
            unContactable: data.unContactable,
            ...(meta ? { meta } : undefined),
            resumeSettingOption: {
                chooseCV: data.profileSetting?.chooseCV,
                chooseRefreshType: data.profileSetting?.chooseRefreshType,
                resumeId: data.profileSetting?.resumeId,
                summary: data.profileSetting?.summary ?? ''
            }
        }
    })
    return ['success']
}
export default syncProfileSettingInfoStore
